import { render, staticRenderFns } from "./ApaItu.vue?vue&type=template&id=6e494fd2&scoped=true"
import script from "./ApaItu.vue?vue&type=script&lang=js"
export * from "./ApaItu.vue?vue&type=script&lang=js"
import style0 from "./ApaItu.vue?vue&type=style&index=0&id=6e494fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e494fd2",
  null
  
)

export default component.exports